import React, { useState } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { CheckMark } from '@lyearn/icons';
import { Box, Typography } from '@lyearn/ui';
import AutocompleteSearch from '@/components/AutocompleteSearch';
import { OrgRoleFilterFragment } from '@/components/FilterManager/EntityFilter/entity/org-role/graphql/fragment/generated/OrgRoleFilter';
import useOrgRolesQuery from '@/components/FilterManager/EntityFilter/entity/org-role/useOrgRolesQuery';

import { classes } from '../styles';
import { OrgRoleSearchProps } from './types';

function OrgRoleSearch({
  orgRoleId,
  onChange,
  user,
  className,
  size = 'large',
  type,
  placeholder,
}: OrgRoleSearchProps) {
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState<string>('');
  const { fetchMore, orgRoles } = useOrgRolesQuery({ filters: { searchText, type } });

  return (
    <AutocompleteSearch
      className={className}
      classes={classes}
      data={orgRoles}
      defaultValue={user?.orgRole as OrgRoleFilterFragment | undefined}
      fetchMore={fetchMore}
      getTextFromValue={(value: OrgRoleFilterFragment | null) => searchText}
      initialValue={user?.orgRole?.name as any}
      isOptionEqualToValue={(option, value) => {
        return option.id === value.id;
      }}
      placeholder={placeholder ?? t('Admin:InviteStaff.OrganizationRolePlaceholder')}
      renderers={{
        renderOption: (role: OrgRoleFilterFragment) => {
          const isSelected = role.id === orgRoleId;

          return (
            <Box className="mb-2 flex w-full items-center justify-between py-10 px-12">
              <Typography
                color={isSelected ? 'text-text-primary' : 'text-text-secondary'}
                variant="body-short-02">
                {role.name}
              </Typography>
              {isSelected ? <CheckMark className="h-20 w-20" fillColorToken="icon-active" /> : null}
            </Box>
          );
        },
      }}
      size={size}
      onChange={onChange}
      onInputChange={setSearchText}
    />
  );
}

export default OrgRoleSearch;
